import { gql } from '@/__generated__/gql'

export const CommonMediaFragment = gql(`
  fragment Common_MediaFragment on Media {
      mediaId
      contentId
      mediaMaestroTitleCode
      policyId
      updatedAt
      duration
      isPublished
      mediaAssets {
        id
        providerKey
      }
  }
`)
